import {PropsWithChildren, useEffect} from 'react'
import { getNestedProp } from '@/helpers'
import Announcement from '@/components/common/Announcement/Announcement'
import {COLORS} from "@/components/common/Announcement/utils";

interface ErrorComponentProps extends PropsWithChildren {
	err?:Error
	res?:Response
	statusCode?:number
	type?:keyof typeof COLORS
	title?:string
	subTitle?:string
}

export const ErrorComponent = ({
	                         err,
							 statusCode,
	                         type,
	                         title,
	                         subTitle,
	                         children
                         }:ErrorComponentProps) => {

	let overrideTitle: string | undefined = undefined
	const defaultErrorText = subTitle || 'An error has occurred.'
	let overrideSubtitle = getNestedProp(err, 'message') || defaultErrorText

	if (err instanceof TypeError || err instanceof ReferenceError) {
		overrideSubtitle = defaultErrorText
	}

	if (statusCode) {
		overrideTitle = statusCode.toString()

		switch (overrideTitle) {
			case '404':
				overrideSubtitle = 'Not Found'
				break
			case '500':
				overrideSubtitle = 'Internal Server Error'
				break
			default:
				break
		}
	}

	useEffect(() => {
		if (err) {
			console.error(err)
		}
	}, [err])

	return (
		<Announcement
			type={type || 'error'}
			title={overrideTitle || title}
			subTitle={overrideSubtitle || subTitle}
		>
			{children}
		</Announcement>
	)
}
